module.exports = __webpack_public_path__ + "img/symbol_0.b41059e0.png";